import AntMenu from "antd/es/menu";
import styled from "styled-components";
import { hexToRGB } from "@shared/utils/misc.ts";
import { phoneMinWidth } from "common/NewLook/layout.ts";

const Menu = styled(AntMenu)`
  .ant-menu-item-selected a::before {
    border-right: 3px solid ${(p) => p.theme.colors.primaryBlue};
  }
  &.ant-menu-inline .ant-menu-sub.ant-menu-inline {
    background: ${(p) => hexToRGB(p.theme.colors.lightestGrey, 0.08)};
  }
  ${(p) =>
    p.theme.isNewLook &&
    `
    .ant-menu-item-selected a::before {
      border-right: none;
    }
    .ant-menu-item-selected {
      font-weight: ${p.theme.typography.fontWeights.SEMI_BOLD};
    }
    .ant-menu-item,
    .ant-menu-submenu-title {
      font-size: 13.5px;
    }
    .ant-menu-item-group-title {
      font-size: 11px;
      font-weight: ${p.theme.typography.fontWeights.BOLD};
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }
    &.ant-menu-inline .ant-menu-sub.ant-menu-inline {
      background: transparent;
    }
  `}
  @media (min-width: ${phoneMinWidth}) {
    .ant-menu-submenu-title:hover {
      color: ${(p) => p.theme.colors.primaryBlue};
    }
  }
`;

export default Menu;
